<button [matMenuTriggerFor]="menu" class="ai-btn" [disabled]="loading">
	<ng-container *ngIf="!loading; else spinner">
		<mat-icon>auto_fix_high</mat-icon>
	</ng-container>
	<ng-template #spinner>
		<mat-spinner diameter="24"></mat-spinner>
	</ng-template>
</button>

<mat-menu #menu="matMenu" class="tiny">
	<button
		*ngIf="tools.includes(WritingTool.FixSpellingGrammar)"
		mat-menu-item
		(click)="onSelect(WritingTool.FixSpellingGrammar)"
	>
		<span i18n="Writing Tools Fix Grammar@@writingToolsFixGrammarLabel">Fix Grammar</span>
	</button>
	<button
		*ngIf="tools.includes(WritingTool.Simplify)"
		mat-menu-item
		(click)="onSelect(WritingTool.Simplify)"
	>
		<span i18n="Writing Tools Simplify@@writingToolsSimplifyLabel">Make Shorter</span>
	</button>
	<button
		*ngIf="tools.includes(WritingTool.Expand)"
		mat-menu-item
		(click)="onSelect(WritingTool.Expand)"
	>
		<span i18n="Writing Tools Expand@@writingToolsExpandLabel">Make Longer</span>
	</button>
	<button
		*ngIf="tools.includes(WritingTool.ChangeTone)"
		mat-menu-item
		[matMenuTriggerFor]="toneMenu"
	>
		<span i18n="Writing Tools Change Tone@@writingToolsChangeToneLabel">Change Tone</span>
	</button>
	<button
		*ngIf="tools.includes(WritingTool.Translate)"
		mat-menu-item
		[matMenuTriggerFor]="translateMenu"
	>
		<span i18n="Writing Tools Translate@@writingToolsTranslateLabel">Translate</span>
	</button>
	<!-- <button
		*ngIf="tools.includes(WritingTool.Summarize)"
		mat-menu-item
		(click)="onSelect(WritingTool.Summarize)"
	>
		<span i18n="Writing Tools Summarize@@writingToolsSummarizeLabel">Summarize </span>
	</button> -->
</mat-menu>

<mat-menu #toneMenu="matMenu" class="tiny">
	<button
		*ngFor="let tone of toneOptions"
		mat-menu-item
		(click)="onSelect(WritingTool.ChangeTone, tone)"
	>
		{{ tone }}
	</button>
</mat-menu>

<mat-menu #translateMenu="matMenu" class="tiny">
	<button
		*ngFor="let language of translateLanguages"
		mat-menu-item
		(click)="onSelect(WritingTool.Translate, language)"
	>
		{{ language }}
	</button>
</mat-menu>
